module.exports = __webpack_public_path__ + "static/media/light-soft.58e19cae.svg";